export function isEmpty(value: undefined | string | number) {
  if (value === "" || value === null || value === undefined) {
    return true;
  } else {
    return false;
  }
}
